export default __webpack_public_path__ + "static/partner1-e01eae08e0fb9b221497c84402c7742b.png";